<template>
	<div class="container">
		<div class="main_box">
			<div class="title_box">
				<div class="title">{{ pwdType == 'yes' ? $t('PWD.txt1') : $t('PWD.txt2') }}</div>
				<div v-if="pwdType == 'no'" class="close" @click="popupClose">
					<van-icon name="clear" size="28" color="#D1D1D1" />
				</div>
			</div>
			<div class="form_box">
				<el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="0px">
					<div class="tips_el">
						<div class="tips">Your password must meet the following requirements:</div>
						<div class="tips">• At least 6 characters</div>
						<div class="tips">• At least one letter</div>
						<div class="tips">• At least one number</div>
					</div>
					<div class="input_el">
						<div class="tit">{{ $t('PWD.txt3') }}</div>
						<el-form-item label="" prop="oldpassword">
							<el-input v-model="ruleForm.oldpassword" :placeholder="$t('PWD.txt3')" clearable show-password></el-input>
						</el-form-item>
					</div>
					<div class="input_el">
						<div class="tit">{{ $t('PWD.txt4') }}</div>
						<el-form-item label="" prop="newpassword">
							<el-input v-model="ruleForm.newpassword" :placeholder="$t('PWD.txt4')" clearable show-password></el-input>
						</el-form-item>
					</div>
					<div class="input_el">
						<div class="tit">{{ $t('PWD.txt5') }}</div>
						<el-form-item label="" prop="newpassword2">
							<el-input v-model="ruleForm.newpassword2" :placeholder="$t('PWD.txt5')" clearable show-password></el-input>
						</el-form-item>
					</div>
				</el-form>
			</div>
			<div class="btn_box">
				<!-- <van-button v-if="pwdType == 'no'" class="btn_el" type="default" round @click="popupClose">{{ $t('PWD.txt6') }}</van-button> -->
				<van-button class="btn_el" round color="linear-gradient(to right, #7BC1FF, #4886FF)" @click="submitForm('ruleForm')">{{ $t('PWD.txt7') }}</van-button>
			</div>
		</div>
		<!--loading-->
		<transition name="fade">
			<div class="loading" v-show="isLoading"><van-loading /></div>
		</transition>
		<!--loading-->
	</div>
</template>

<script>
import { checkPwd } from '@/api/public';
export default {
	props: [
		'type'
	],
	components:{
		//
	},
	data() {
		return {
			isLoading: true,
			pwdType: this.type,
			ruleForm: {
				oldpassword: '',
				newpassword: '',
				newpassword2: ''
			},
			rules: {
				oldpassword: [
					{ required: true, message: this.$t('PWD.txt3'), trigger: 'blur' },
				],
				newpassword: [
					{ required: true, message: this.$t('PWD.txt4'), trigger: 'blur' },
				],
				newpassword2: [
					{ required: true, message: this.$t('PWD.txt5'), trigger: 'blur' },
				]
			}
		}
	},
	created(){
		let that = this;
	},
	mounted() {
		let that = this;
		that.isLoading = false;
	},
	watch: {
		//
	},
	methods: {
		//提交信息
		submitForm(formName) {
			let that = this;
			that.$refs[formName].validate((valid) => {
				if(valid) {
					//校验密码
					if(that.ruleForm.oldpassword == that.ruleForm.newpassword) {
						// that.$message({ type: 'warning', message: '旧密码和新密码不能相同' });
						that.$toast(that.$t('PWD.txt8'));
						return false;
					}
					// if(that.ruleForm.newpassword == '123456') {
					// 	// that.$message({ type: 'warning', message: '新密码不能是初始密码' });
					// 	that.$toast(that.$t('PWD.txt9'));
					// 	return false;
					// }
					if(that.ruleForm.newpassword != that.ruleForm.newpassword2) {
						// that.$message({ type: 'warning', message: '新密码和确认新密码不同' });
						that.$toast(that.$t('PWD.txt10'));
						return false;
					}
					if(!/^(?=.*[A-Za-z])(?=.*\d).{6,}$/.test(that.ruleForm.newpassword)) {
						that.$toast('At least 6 characters, including one letter and one number.');
						return false;
					}
					that.$toast.loading({ duration: 0, forbidClick: true });
					checkPwd({
						authtoken: localStorage.getItem('userToken'),
						oldpassword: that.ruleForm.oldpassword,
						newpassword: that.ruleForm.newpassword,
						newpassword2: that.ruleForm.newpassword2
					}).then(res => {
						if(res.code == 200) {
							localStorage.clear();
							sessionStorage.clear();
							// that.$message({ type: 'success', message: '密码重置成功' });
							that.$toast(that.$t('PWD.txt11'));
							setTimeout(() => {
								that.$router.replace('/login');
							}, 1500);
						}
					});
				}else {
					return false;
				}
			});
		}
	}
}
</script>

<style lang="less" scoped>
.main_box{
	max-width: 1200px;
	margin: 0 auto;
	position: relative;
	.btn_box{
		padding: 0 40px 50px 0;
		text-align: right;
		.btn_el{
			margin-left: 10px;
			padding: 12px 36px;
			.van-button__text{
				font-size: 16px;
			}
		}
	}
	.form_box{
		padding: 50px 40px;
		.input_el{
			.tit{
				padding-bottom: 5px;
				font-size: 14px;
				color: #333333;
			}
		}
		.tips_el{
			margin: 10px 0 20px 0;
			border-radius: 6px;
			background-color: #ffb1001a;
			padding: 10px 8px;
			.tips{
				padding: 2px 0;
				font-size: 16px;
				font-weight: bold;
			}
		}
	}
	.title_box{
		display: flex;
		align-items: center;
		padding: 20px 30px;
		// border-bottom: 1px solid #E5E5E5;
		.title{
			flex: 1;
			font-size: 20px;
			font-weight: bold;
			color: #333333;
		}
		.close{
			width: auto;
			cursor: pointer;
		}
	}
}
</style>
